import { render, staticRenderFns } from "./TournamentLanding.vue?vue&type=template&id=a7f1bc4a&scoped=true"
import script from "./TournamentLanding.vue?vue&type=script&lang=js"
export * from "./TournamentLanding.vue?vue&type=script&lang=js"
import style0 from "./TournamentLanding.vue?vue&type=style&index=0&id=a7f1bc4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f1bc4a",
  null
  
)

export default component.exports